import { render, staticRenderFns } from "./ProcessListDrawer.vue?vue&type=template&id=2def0f08&"
import script from "./ProcessListDrawer.vue?vue&type=script&lang=js&"
export * from "./ProcessListDrawer.vue?vue&type=script&lang=js&"
import style0 from "./ProcessListDrawer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports